import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const ExpandIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5443 0.2625C10.8868 -0.0875 11.4006 -0.0875 11.7431 0.2625C12.0856 0.6125 12.0856 1.1375 11.7431 1.4875L6.60533 6.7375C6.26282 7.0875 5.74904 7.0875 5.40652 6.7375L0.268743 1.925C-0.0737752 1.575 -0.0737752 1.05 0.183114 0.7C0.525632 0.35 1.03941 0.35 1.38193 0.6125L6.00593 4.9L10.5443 0.2625Z"
        {...svgAttrs}
      />
    </svg>
  );
};

export default ExpandIcon;
